var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProject9(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_823_76582)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.75 11.664L10.293 15.121C9.734 15.68 8.961 16 8.172 16H8V15.828C8 15.039 8.32 14.266 8.879 13.707L12.336 10.25L13.75 11.664ZM14.793 7.793L13.75 8.836L15.164 10.25L16.207 9.207C16.597 8.817 16.597 8.183 16.207 7.793C15.817 7.403 15.184 7.402 14.793 7.793ZM24 12C24 18.617 18.617 24 12 24C5.383 24 0 18.617 0 12C0 5.383 5.383 0 12 0C18.617 0 24 5.383 24 12ZM17.621 6.379C16.451 5.209 14.549 5.209 13.379 6.379L7.465 12.293C6.521 13.237 6 14.493 6 15.828V17C6 17.553 6.447 18 7 18H8.172C9.507 18 10.763 17.479 11.707 16.535L17.621 10.621C18.791 9.451 18.791 7.549 17.621 6.379Z",
    fill: "#CAC4D0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_823_76582"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProject9);
export default __webpack_public_path__ + "static/media/project9.d5ca3c49.svg";
export { ForwardRef as ReactComponent };